module.exports = __webpack_public_path__ + "img/pin-unpin.696fff99.png";